import JSZip from 'jszip'
import { createLogger } from '../app/logger'

export default async function unzip(data: any) {
  const logger = createLogger({
    prefix: 'entriesUnzip'
  })

  const jszip = await new JSZip().loadAsync(data, { createFolders: false, })

  logger.info('unzip', { files: jszip.files, jszip })
  return await jszip.files['entries.json'].async('arraybuffer')
}
